import { Navigate } from 'react-router';

import { ROUTES } from '@/constants';
import { useCachedRegionSeason } from '@/hooks';

const HomeRedirect = () => {
  const { value } = useCachedRegionSeason();

  if (!value) {
    return <Navigate to='/not-found' replace />;
  }

  return (
    <Navigate
      to={`region/${value.region}/season/${value.season}/${ROUTES.FIELD_ALLOCATION}`}
      replace
    />
  );
};

export default HomeRedirect;
